<template>
    <b-modal
            id="add-managers"
            ref="add-managers"
            modal-class="add-member-to-department"
            size="sm-size"
            centered
            hide-footer
            hide-header
            @hide="close"
    >
        <div class="modal-head">
            <h2 class="modal-title">
                {{ label.get('add_managers_to_department') }}
            </h2>
        </div>
        <div class="modal-content">
                <div
                        class="department-wrapper"
                >
                <span class="description">
                    {{label.get('when_you_add_a_manger_to_a_department_description')}}
                </span>
                    <div class="content-wrapper hasScroll">
                        <perfect-scrollbar>
                            <div>
                                <ul class="department-members">
                                    <li
                                            v-for="(member, idx) in managers"
                                            :key="idx"
                                    >
                                        <b-form-checkbox
                                                v-model="member.selected"
                                                class="radio-checkbox"
                                        >
                                            {{ member.name }}
                                        </b-form-checkbox>
                                    </li>
                                </ul>
                            </div>
                        </perfect-scrollbar>
                    </div>

                </div>
        </div>



        <div class="modal-footer">
            <div class="form-buttons">
                <button
                        class="atto-btn cancel"
                        @click="close"
                >
                    {{ label.get('cancel') }}
                </button>
                <button
                        class="atto-btn submit"
                        @click="addManagersToDepartment()"
                >
                    {{ label.get('department_add_managers') }}
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import DepartmentService from '../services/DepartmentService';
    export default {
        name: "AddManagersToDepartmentComponent",
        props: {
            department: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                managers: this.getManagersFromStore()
            }
        },
        mounted() {
            this.$refs['add-managers'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideAddManagersToDep');
            },
            getManagersFromStore() {
                this.$store.commit('showLoading');
                DepartmentService.getDepartmentManagers(this.department.id).then((result) => {
                    this.managers = result;
                    this.$store.commit('hideLoading');
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                    console.log(error)
                });
               // return this.$store.state.members.filter((item) => {
               //     return item.role_id === 2;
               // });
            },
            addManagersToDepartment(){
                const selectedManagers = this.managers.filter((member) => {
                    return member.selected;
                });

                if(selectedManagers.length === 0) {
                    return false;
                }
                const memberIds = selectedManagers.map((item) => { return item.id; });

                if(memberIds.length === 0) {
                    return false;
                }

                this.$store.commit('showLoading');
                DepartmentService.addManagersToDepartment( this.department.id,{
                    managers: memberIds
                }).then(() => {
                    this.$store.commit('hideLoading');
                    this.$root.$emit('hideAddManagersToDep', selectedManagers);
                }).catch(() => {
                    this.$store.commit('hideLoading');
                    this.$awn.alert(this.label.get('an_error_occurred_while_adding_members_to_this_department'));
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.add-member-to-department .modal-head{
  padding-bottom: 0;
}
    .department-wrapper{
        span{
            &.description{
                padding: 0 0 24px;
                max-width: 336px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 12px auto 24px;
                font: 400 14px/20px 'Roboto', sans-serif;
                color: #666666;
                border-bottom: 1px solid $atto-light-grey;
             }
        }
    }
</style>